import React from "react";
import img1 from './1.png'
import img2 from './2.png'
import img3 from './3.png'
import img4 from './4.png'
import imgPress from './press.png'

const AwardsAndPress = () => {
  return <div style={{ marginTop: 16 }}>
    <h5>Press</h5>
    <img alt=""  src={imgPress} style={{ width: 200 }} />
  </div>
};

const Content = () => {
  return <div>
    <img alt=""  src={img2} style={{ width: '100%', marginBottom: 16 }} />
    <img alt=""  src={img3} style={{ width: '100%', marginBottom: 16 }} />
    <img alt=""  src={img4} style={{ width: '100%', marginBottom: 16 }} />
  </div>
};

const Project = () => {
  return {
    id: "lineas",
    preview: img1,
    title: "360° Locomotive",
    tag: "Corporate",
    description: 'We helped Lineas, a major private railfreight & logistics operator in Europe, to better understand the relation wetween how a locomotive is used and how it has to be maintained. In order to do so we came up with an custom data visualisation that provides a 360° view for each individual locomotive. This view allows to understand at a glance how a locomotive has been used over the course of a calendar year.',
    awardsAndPress: <AwardsAndPress />,
    date: new Date("2017-11-01"),
    content: <Content />
  }
};

export default Project;